'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProduct = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * updateProduct
 * 
 * Updates a product.
 * @param {String} feis_id 
 * @param {String} product_id 
 * @param {Product} product 
 */
var updateProduct = exports.updateProduct = function updateProduct(feis_id, product_id, product) {
  return function (dispatch) {

    return dispatch(_defineProperty({
      feis_id: feis_id,
      product_id: product_id

    }, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feiseanna/' + feis_id + '/products/' + product_id,
        method: 'PUT',
        data: product
      },
      types: ['UPDATE_PRODUCT_START', 'UPDATE_PRODUCT', 'UPDATE_PRODUCT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/products/updateProduct.js
// module id = 664
// module chunks = 0